import type { SearchDataModel } from "~/types/models/SearchData.model";
import { useApiService } from "./useApiService";
import type { IArticle, IAuthor } from "~/types";
import type { IListResponse } from "~/types/IListResponse";

export const useRtApiService = () => {
  const { getFetchData, postFetchData } = useApiService();

  const getArticlesByResearchTopicId = async (
    researchTopicId: number,
    params: SearchDataModel
  ): Promise<IArticle[]> => {
    return await postFetchData<IArticle[]>(
      `/api/v3/research-topics/${researchTopicId}/articles`,
      params
    );
  };

  const getAuthorsByResearchTopicId = async (
    researchTopicId: number,
    params: SearchDataModel
  ): Promise<IListResponse<IAuthor>> => {
    const articleAuthors = await getFetchData<IListResponse<IAuthor>>(
      `/api/v3/research-topics/${researchTopicId}/authors?offset=${params.skip}&limit=${params.limit}`,
      "articleAuthors"
    );
    return articleAuthors;
  };

  const getTotalArticles = async (researchTopicId: number): Promise<number> => {
    const total = await getFetchData<number>(
      `/api/v3/research-topics/${researchTopicId}/articles/count`,
      "articleCount"
    );
    return total;
  };

  const getTotalAuthors = async (researchTopicId: number): Promise<number> => {
    const total = await getFetchData<number>(
      `/api/v3/research-topics/${researchTopicId}/authors/count`,
      "authorsCount"
    );
    return total;
  };

  return {
    getArticlesByResearchTopicId,
    getAuthorsByResearchTopicId,
    getTotalArticles,
    getTotalAuthors
  };
};
